import Reveal from "@/components/base/Reveal";
import { rankingTopics } from "@/mocks/siteContent";

const tagStyle: Record<string, string> = {
  资料: "bg-secondary-100 text-secondary-900",
  账号: "bg-primary-100 text-primary-700",
  动态: "bg-accent-100 text-accent-700",
  争议: "bg-primary-100 text-primary-700",
  八卦: "bg-secondary-100 text-secondary-900",
};

export default function RankingSection() {
  return (
    <section id="ranking" className="scroll-mt-20 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-accent-500"></span>
              <span className="font-label text-xs md:text-sm tracking-widest text-accent-700 uppercase">
                Hot Topics
              </span>
            </div>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
              网络热搜话题榜
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              汇总与夏目彩春相关的热门搜索与讨论方向，按讨论热度排序。榜单只反映话题受关注程度，不代表内容已被证实。
            </p>

            <div className="mt-6 rounded-2xl border border-background-200 bg-background-100 p-5">
              <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                <i className="ri-line-chart-line text-accent-600"></i>
                热度是怎么来的
              </h3>
              <p className="mt-2.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                综合各平台的搜索量、讨论量与转载频次做粗略估算，用于呈现话题的相对冷热，并非精确统计。
              </p>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-8" delay={100}>
            <div className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
              <ul className="divide-y divide-background-200">
                {rankingTopics.map((t) => (
                  <li
                    key={t.rank}
                    className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 hover:bg-background-100 transition-colors"
                  >
                    <span
                      className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
                        t.rank <= 3
                          ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {t.rank}
                    </span>

                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="text-sm text-foreground-900 font-medium truncate">
                          {t.title}
                        </p>
                        <span
                          className={`hidden sm:inline-block text-[11px] px-2 py-0.5 rounded-full font-label shrink-0 ${
                            tagStyle[t.tag] ?? "bg-background-200 text-foreground-700"
                          }`}
                        >
                          {t.tag}
                        </span>
                      </div>
                      <div className="mt-2 h-1.5 rounded-full bg-background-200 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                          style={{ width: `${t.heat}%` }}
                        ></div>
                      </div>
                    </div>

                    <span className="text-xs md:text-sm font-label text-foreground-600 w-8 text-right shrink-0">
                      {t.heat}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}